import { Mapper } from "@shared/interfaces";
import { CardDTO, ICardDTO } from "./Card.dto";

export interface ICanvasDTO {
    id?: string;
    title: string;
    idDoctor: string;
    date: string;
    trusted: boolean;
    cards: ICardDTO[];
}

export class CanvasDTO implements Mapper<ICanvasDTO> {
    constructor(
        public title: string,
        public idDoctor: string,
        public date: string,
        public trusted: boolean,
        public cards: CardDTO[] = [],
        public id?: string,
    ) { }

    public getJSON(): ICanvasDTO {
        const jsonObject = {
            title: this.title,
            idDoctor: this.idDoctor,
            date: this.date,
            trusted: this.trusted,
            cards: this.cards.map(card => card.getJSON())
        }

        return jsonObject;
    }
}